import React from 'react';
import FlowGlobalEdge from '../components/edges/FlowGlobalEdge';
import LoopEdge from '../components/edges/LoopEdge';
import SelectableDefaultEdge from '../components/edges/SelectableDefaultEdge';
import FileSave from '../components/FileSave/FileSave';
import ImageComponent from '../components/FormNodes/ImageComponent/ImageComponent';
import InputNodeDisplay from '../components/FormNodes/InputNodeDisplay/InputNodeDisplay';
import LinesNode from '../components/FormNodes/LinesNode';
import List from '../components/FormNodes/ListNode/List';
import OutputNodeDisplay from '../components/FormNodes/OutputNodeDisplay/OutputNodeDisplay';
import ShortText from '../components/FormNodes/ShortText/ShortText';
import SubmitButtonNode from '../components/FormNodes/SubmitButtonNode/SubmitButtonNode';
import TitleNode from '../components/FormNodes/TitleNode/TitleNode';
import PullHubSpotData from '../components/HubSpotDataNode/PullHubSpotDataNode';
import AiAudioGenerator from '../components/nodes/AiAudioGenerator';
import AiAudioTranscriber from '../components/nodes/AiAudioTranscriber';
import AiMusicGenerator from '../components/nodes/AiMusicGenerator';
import AiTextGenerator from '../components/nodes/AiTextGenerator';
import AiTextSummarizer from '../components/nodes/AiTextSummarizer';
import AiVideoGenerator from '../components/nodes/AiVideoGenerator';
import ApiCaller from '../components/nodes/ApiCaller';
import ApiInput from '../components/nodes/ApiInput';
import McpServer from '../components/nodes/McpServer';
import ApiOutput from '../components/nodes/ApiOutput';
import DecisionPaths from '../components/nodes/DecisionPaths';
import DynamicSettingNode from '../components/nodes/DynamicSettingNode';
import FlowCaller from '../components/nodes/FlowCaller';
import FlowCreator from '../components/nodes/FlowCreator';
import FlowDataCaller from '../components/nodes/FlowDataCaller';
import FlowGlobalNode from '../components/nodes/FlowGlobalNode';
import ImageGenerator from '../components/nodes/ImageGenerator';
import ImageReader from '../components/nodes/ImageReader';
import LargeMemory from '../components/nodes/LargeMemory';
import LibraryNode from '../components/nodes/LibraryNode';
import MathFunction from '../components/nodes/MathFunction';
import MediaBox from '../components/nodes/MediaBox';
import NodesGroup from '../components/nodes/NodesGroup';
import ObjectCaller from '../components/nodes/ObjectCaller';
import OutputControllerNode from '../components/nodes/OutputControllerNode';
import ProcessCounter from '../components/nodes/ProcessCounter';
import ReportBuilderNode from '../components/nodes/ReportBuilderNode';
import RichTextBoxNode from '../components/nodes/RichTextBoxNode';
import Scripting from '../components/nodes/Scripting';
import SecApiNode from '../components/nodes/SecApiNode';
import SequenceNode from '../components/nodes/SequenceNode';
import SmallMemory from '../components/nodes/SmallMemory';
import SqlQuerier from '../components/nodes/SqlQuerier';
import StickyNote from '../components/nodes/StickyNote';
import StoredDataCaller from '../components/nodes/StoredDataCaller';
import TableOutput from '../components/nodes/TableOutput';
import TableProcessor from '../components/nodes/TableProcessor';
import TextBoxNode from '../components/nodes/TextBoxNode';
import UsCensusNode from '../components/nodes/UsCensusNode';
import WebAmazon from '../components/nodes/WebAmazon';
import WebCrawling from '../components/nodes/WebCrawling';
import WebSearch from '../components/nodes/WebSearch';
import WebTrends from '../components/nodes/WebTrends';
import PullData from '../components/PullDataNode/PullDataNode';
import PushData from '../components/PushDataNode/PushDataNode';
import ThirdPartyIntegrationNode from '../components/ThirdPartyIntegration/ThirdPartyIntegrationNode';

const withRemountKey = (Component: React.ComponentType<any>): React.ComponentType<any> =>
  (props: any) => <Component key={props.data?._remountKey} {...props} />;

export const nodeTypes = {
  globalStarter: withRemountKey(FlowGlobalNode),
  commandTextNode: withRemountKey(AiTextGenerator),
  outputController: withRemountKey(OutputControllerNode),
  reportBuilder: withRemountKey(ReportBuilderNode),
  fluxObject: withRemountKey(SmallMemory),
  varInputNode: withRemountKey(ApiInput),
  outputObjectNode: withRemountKey(ApiOutput),
  conditionNode: withRemountKey(DecisionPaths),
  textBox: withRemountKey(TextBoxNode),
  richTextBox: withRemountKey(RichTextBoxNode),
  voiceBoxNode: withRemountKey(AiAudioGenerator),
  commandContentNode: withRemountKey(LargeMemory),
  nodesBox: withRemountKey(ObjectCaller),
  fluxBox: withRemountKey(FlowCaller),
  storedDataCaller: withRemountKey(StoredDataCaller),
  imageGenerator: withRemountKey(ImageGenerator),
  nodesGroup: withRemountKey(NodesGroup),
  arrayNode: withRemountKey(SequenceNode),
  webSearch: withRemountKey(WebSearch),
  // webMedia: WebMedia,
  // webLocations: WebLocations,
  // webNews: WebNews,
  deepRefNode: withRemountKey(FlowDataCaller),
  mathFunction: withRemountKey(MathFunction),
  scripting: withRemountKey(Scripting),
  counterNode: withRemountKey(ProcessCounter),
  tableProcessor: withRemountKey(TableProcessor),
  outputTable: withRemountKey(TableOutput),
  dynamicSettingsNode: withRemountKey(DynamicSettingNode),
  audioReaderNode: withRemountKey(AiAudioTranscriber),
  commandMusicNode: withRemountKey(AiMusicGenerator),
  apiCaller: withRemountKey(ApiCaller),
  mcpNode: withRemountKey(McpServer),
  sqlQuerier: withRemountKey(SqlQuerier),
  imageReaderNode: withRemountKey(ImageReader),
  webCrawling: withRemountKey(WebCrawling),
  webTrends: withRemountKey(WebTrends),
  animationNode: withRemountKey(AiVideoGenerator),
  usCensusNode: withRemountKey(UsCensusNode),
  documentSummarizer: withRemountKey(AiTextSummarizer),
  secApiNode: withRemountKey(SecApiNode),
  webAmazon: withRemountKey(WebAmazon),
  stickyNote: withRemountKey(StickyNote),
  pullData: withRemountKey(PullData),
  pushData: withRemountKey(PushData),
  fileSave: withRemountKey(FileSave),
  nodesAdd: withRemountKey(FlowCreator),
  hubSpotCRM: withRemountKey(PullHubSpotData),
  mediaBox: withRemountKey(MediaBox),
  libraryNode: withRemountKey(LibraryNode),
  thirdPartyIntegration: withRemountKey(ThirdPartyIntegrationNode),
};

export const edgeTypes = {
  custom: FlowGlobalEdge,
  loopEdge: LoopEdge,
  default: SelectableDefaultEdge,
};

export const formNodeTypes = {
  title: TitleNode,
  shortText: ShortText,
  listNode: List,
  image: ImageComponent,
  submit: SubmitButtonNode,
  inputDisplay: InputNodeDisplay,
  outputDisplay: OutputNodeDisplay,
  linesNode: LinesNode,
};
